module.exports = __webpack_public_path__ + "img/CCS.1dc3fc79.png";